const styles = {
    listItem: {
        padding: "5px 0px 5px 10px",
    },
    listItemIcon: {
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "primary.second",
    },
    listItemText: {
        margin: "0px 0px 0px -35px",
    },
    noData: {
        color: "primary.third"
    }
}

export default styles;